import React, { useState, useEffect, useCallback } from "react";
import EditIcon from "../../../assets/icons/lucide_edit.svg";
import SearchIcon2 from "../../../assets/icons/SearchIcon2.svg";
import { Close, SettingsApplications } from "@material-ui/icons";
import HeaderDescription from "../../../components/commons/HeaderDescription";
import MapEventModal from "./Modal/MapEventModal";
import ThunksBooking from "../../../redux/actions/thunks/bookings";
import { connect } from "react-redux";
import { toastMessage } from "../../../helpers/toastMessage";
import Stack from "@mui/material/Stack";
import LinearProgress from "@mui/material/LinearProgress";
import MOButtonV2 from "../../../components/commons/MOButtonV2";
import moment from "moment";
import NoShowReportModal from "./Modal/NoShowReportModal";

const ManualEventTriggerMain = ({
  token,
  getBookingDetailByRef,
  manualDriverEventTrigger,
}) => {
  const [searchValue, setSearchValue] = useState("");
  const [bookingDetail, setBookingDetail] = useState(false);
  const [eventDetail, setEventDetail] = useState(null);
  const [loading, setLoading] = useState(false);
  const [mapModal, setMapModal] = useState(false);
  const [noShowModal, setNoShowModal] = useState(false);

  const driverEventApiHandler = async (eventName, bookingId, lat, long) => {
    try {
      setLoading(true);
      const payload = {
        bookingId: bookingId,
        eventName: eventName,
        lat: lat,
        long: long,
      };

      await manualDriverEventTrigger(payload);
      const data = await getBookingDetailByRef(searchValue);
      setBookingDetail(data);
      setMapModal(false);
      toastMessage("success", "Driver event successfully submitted");
    } catch (error) {
      toastMessage(
        "error",
        error.message || "Error: Driver event is not save successfully",
      );
    } finally {
      setLoading(false);
    }
  };

  const driverNoShowEventApiHandler = async (
    eventName,
    bookingId,
    lat,
    long,
    reason = null,
    picture = [],
  ) => {
    try {
      setLoading(true);
      const payload = {
        bookingId: bookingId,
        eventName: eventName,
        location: {
          lat: lat,
          lng: long,
        },
        lat: lat,
        long: long,
      };
      if (reason) {
        payload.reason = reason;
      }
      if (picture?.length > 0) {
        payload.picture = picture;
      }
      await manualDriverEventTrigger(payload);
      const data = await getBookingDetailByRef(searchValue);
      setBookingDetail(data);
      setNoShowModal(false);
      toastMessage("success", "Driver event successfully submitted");
    } catch (error) {
      toastMessage(
        "error",
        error.message || "Error: Driver event is not save successfully",
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!searchValue.trim()) {
      setBookingDetail(null);
      setLoading(false);
      return;
    }

    const delayDebounceFn = setTimeout(async () => {
      setLoading(true);
      try {
        const data = await getBookingDetailByRef(searchValue);
        console.log("data", data);
        if (data) {
          setBookingDetail(data);
        } else {
          toastMessage("error", "Booking not found");
        }
      } catch (error) {
        console.error("Search Error:", error);
        setBookingDetail(null);
      } finally {
        setLoading(false);
      }
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchValue]);
  return (
    <>
      <div>
        {/* Header section */}
        <div className="mt-18 flex justify-content-between">
          <div>
            <HeaderDescription
              heading="Manual Driver Event Trigger"
              description="Search for a specific Booking ID to verify its status. Use this tool to manually trigger and update driver events that failed to execute automatically."
            />
          </div>
        </div>

        {bookingDetail && (
          <div className="flex justify-content-end mt-12">
            <div className="">
              {/* <div
              className={`searching-input-section  `}
              style={{
                width: 280,
              }}
            >
              <img src={SearchIcon2} />
              <input
                className="width-full"
                placeholder="Search Booking..."
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
              />

              <Close
                style={{
                  color: "#737373",
                  width: "14px",
                  height: "14px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setSearchValue("");
                }}
              />
            </div> */}

              <MOButtonV2
                type="button"
                text={"Clear"}
                textColor="#ffffff"
                radius={4}
                widthSize={137}
                height={32}
                padding={"10px 12px"}
                backgroundColor="#29AEE6"
                fontSize={11}
                onClick={() => {
                  setBookingDetail(null);
                  setSearchValue("");
                }}
              />
            </div>
          </div>
        )}

        {loading ? (
          <Stack
            sx={{ width: "100%", color: "grey.500" }}
            spacing={2}
            style={{
              marginTop: 40,
            }}
          >
            <LinearProgress color="success" />
            <LinearProgress color="success" />
            <LinearProgress color="success" />
          </Stack>
        ) : (
          <>
            {bookingDetail ? (
              <div>
                <div className="bg-white mt-16 border-radius-8">
                  {/* Header */}
                  <div className="px-20 pt-16">
                    <HeaderDescription
                      heading={`Booking Driver Event Details (${searchValue})`}
                      description="Review the execution status of driver events associated with this booking. Identify pending or failed triggers and use the edit option to manually execute them."
                    />
                  </div>
                  <div className="bg-white border-radius-8">
                    <table className="custom-table-v3">
                      <thead>
                        <tr>
                          <th>Event Name</th>
                          <th>Latitude</th>
                          <th>Longitude</th>
                          <th>Triggered By</th>
                          <th>Triggered Time</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {[
                          {
                            eventName: "DRIVER_DEPARTED_TO_PICKUP",
                          },
                          {
                            eventName: "DRIVER_ARRIVED_AT_PICKUP",
                          },
                          {
                            eventName: "DRIVER_DEPARTED_TO_DROPOFF",
                          },
                          {
                            eventName: "DRIVER_ARRIVED_AT_DROPOFF",
                          },
                        ]?.map((row, index) => {
                          const isEventExist =
                            bookingDetail?.driverEvents?.find(
                              (de) => de.eventName === row.eventName,
                            );

                          return (
                            <tr key={index}>
                              <td>{row?.eventName?.split("_").join(" ")}</td>
                              <td>{isEventExist ? isEventExist?.lat : ""}</td>
                              <td>{isEventExist ? isEventExist?.long : ""}</td>
                              <td>
                                {isEventExist
                                  ? isEventExist?.user?.displayName
                                  : ""}
                              </td>
                              <td>
                                {isEventExist
                                  ? moment(isEventExist.createdAt).format("LLL")
                                  : ""}
                              </td>
                              <td>
                                {isEventExist ? (
                                  <>
                                    <p
                                      className="rm-service-leave-badge "
                                      style={{ width: "max-content" }}
                                    >
                                      Done
                                    </p>
                                  </>
                                ) : (
                                  <img
                                    src={EditIcon}
                                    className="cursor-pointer"
                                    style={{ width: "20px", height: "20px" }}
                                    onClick={() => {
                                      setEventDetail(row.eventName);
                                      setMapModal(true);
                                    }}
                                  />
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* no show section */}
                {/* <div className="bg-white mt-16 border-radius-8 p-20 flex justify-content-end ">
                  <MOButtonV2
                    type="button"
                    text={"No Show Reported"}
                    textColor="#C8102E"
                    radius={4}
                    widthSize={137}
                    height={32}
                    padding={"10px 12px"}
                    backgroundColor="#FFDCE0"
                    fontSize={11}
                    onClick={() => {
                      setNoShowModal(true);
                    }}
                  />
                </div> */}

                {/* No Show Section */}
                <div className="bg-white mt-16 border-radius-8 p-20 border-light">
                  {bookingDetail?.driverEvents?.find(
                    (de) =>
                      de.eventName === "DRIVER_SUBMITTED_CUSTOMER_NO_SHOW",
                  ) ? (
                    <div className="manual-event-trigger-no-show-display-card">
                      <div className="flex justify-content-between align-items-center mb-12">
                        <div className="flex align-items-center gap-8">
                          <span className="no-show-dot-indicator"></span>
                          <h4 className="m-0 text-dark-grey fs-14">
                            Customer No-Show Status
                          </h4>
                        </div>
                        <div className="no-show-status-badge">Reported</div>
                      </div>

                      <div className="no-show-details-grid">
                        <div className="no-show-detail-item">
                          <label>Triggered By</label>
                          <p>
                            {bookingDetail.driverEvents.find(
                              (de) =>
                                de.eventName ===
                                "DRIVER_SUBMITTED_CUSTOMER_NO_SHOW",
                            )?.user?.displayName || "System"}
                          </p>
                        </div>

                        <div className="no-show-detail-item">
                          <label>Coordinates</label>
                          <p>
                            {(() => {
                              const event = bookingDetail.driverEvents.find(
                                (de) =>
                                  de.eventName ===
                                  "DRIVER_SUBMITTED_CUSTOMER_NO_SHOW",
                              );
                              return `${event?.lat}, ${event?.long}`;
                            })()}
                          </p>
                        </div>

                        <div className="no-show-detail-item">
                          <label>Timestamp</label>
                          <p>
                            {moment(
                              bookingDetail.driverEvents.find(
                                (de) =>
                                  de.eventName ===
                                  "DRIVER_SUBMITTED_CUSTOMER_NO_SHOW",
                              )?.createdAt,
                            ).format("MMM D, YYYY • HH:mm")}
                          </p>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="flex justify-content-between align-items-center">
                      <div>
                        <h4 className="m-0 text-dark-grey fs-14">
                          Report Customer No-Show
                        </h4>
                        <p className="m-0 text-light-grey fs-12">
                          This will record the driver's current coordinates and
                          reason for the report.
                        </p>
                      </div>
                      <MOButtonV2
                        type="button"
                        text={"Trigger No-Show"}
                        textColor="#C8102E"
                        radius={6}
                        widthSize={160}
                        height={36}
                        padding={"0 16px"}
                        backgroundColor="#FFDCE0"
                        fontSize={12}
                        onClick={() => setNoShowModal(true)}
                      />
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <section className="manual-event-trigger-container mt-16">
                <div className="manual-event-trigger-header">
                  <div className="manual-event-trigger-icon-wrapper">
                    <SettingsApplications
                      className="text-primary"
                      style={{ fontSize: 32 }}
                    />
                  </div>

                  <div className="manual-event-trigger-search-section">
                    <HeaderDescription
                      heading="Booking Driver Event Details"
                      description="Enter a Booking ID or Reference to inspect execution logs and manually override driver events."
                    />
                  </div>
                </div>

                <div className="manual-event-trigger-input-wrapper">
                  <img
                    src={SearchIcon2}
                    className="manual-event-trigger-search-icon"
                  />
                  <input
                    type="text"
                    className="manual-event-trigger-input text-black"
                    placeholder="Search by Booking ID, Ref ID, or Customer Ref..."
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                  />
                </div>
              </section>
            )}
          </>
        )}

        {mapModal && (
          <MapEventModal
            modalOpen={mapModal}
            setModalOpen={setMapModal}
            eventDetail={eventDetail}
            bookingDetail={bookingDetail}
            loading={loading}
            apiCall={(eventName, bookingId, lat, long) => {
              driverEventApiHandler(eventName, bookingId, lat, long);
            }}
          />
        )}

        {noShowModal && (
          <NoShowReportModal
            token={token}
            modalOpen={noShowModal}
            setModalOpen={setNoShowModal}
            eventDetail={"DRIVER_SUBMITTED_CUSTOMER_NO_SHOW"}
            bookingDetail={bookingDetail}
            loading={loading}
            apiCall={(eventName, bookingId, lat, long, reason, imageUrls) => {
              driverNoShowEventApiHandler(
                eventName,
                bookingId,
                lat,
                long,
                reason,
                imageUrls,
              );
            }}
          />
        )}
      </div>
    </>
  );
};

const mapState = (state) => ({
  token: state.userInfo.token,
});

const mapDispatch = {
  getBookingDetailByRef: ThunksBooking.getBookingDetailByRef,
  manualDriverEventTrigger: ThunksBooking.manualDriverEventTrigger,
};

export default connect(mapState, mapDispatch)(ManualEventTriggerMain);
